export type StatusTone = "muted" | "active" | "confirmed" | "danger";

const TONE: Record<StatusTone, string> = {
  muted: "bg-ink-700 text-muted",
  active: "bg-ledger-600/30 text-ledger-400",
  confirmed: "bg-signal-500/20 text-signal-400",
  danger: "bg-red-900/40 text-red-300",
};

const DOT: Record<StatusTone, string> = {
  muted: "bg-muted",
  active: "bg-ledger-400 animate-pulse",
  confirmed: "bg-signal-400",
  danger: "bg-red-400",
};

/** Same visual language as ValidityBadge (Recover) — a small dot plus a colored label pill. */
export function StatusPill({ tone, children }: { tone: StatusTone; children: React.ReactNode }) {
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-mono ${TONE[tone]}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${DOT[tone]}`} aria-hidden="true" />
      {children}
    </span>
  );
}
